// react documenation used: https://react.dev/learn
// axios documentation used: https://axios-http.com/docs/intro
// this functionality has been seperated fromt he login page as it is being reused in the routes from app.js
// authContext functionality was inspired from the code used in this documentation: https://medium.com/@Jskiiii/guide-to-implementing-authentication-in-react-using-usecontext-hook-373ec1a364fa
import React, { createContext, useContext, useState } from "react";
import axios from "axios";

const AuthContext = createContext();
// exporting here allows these functions to be accessed when importing the AuthContext file.
export function useAuth() {
  return useContext(AuthContext);
}

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("token")
  );
  const apiUrl = process.env.REACT_APP_API_URL;

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${apiUrl}/api/users/login`, {
        email,
        password,
      });
      const { token } = response.data;
      if (token) {
        // stores token in localsession which can be found in the browser client side
        localStorage.setItem("token", token);
        setIsAuthenticated(true);
        return true;
      }
    } catch (error) {
      console.error("Login error:", error.response || error);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
  };

  const value = {
    isAuthenticated,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
